<template>
    <div class="lang">
        <div class="popup4" :class="{ active: popupShow }">
            <div class="popup__inner">
                <div class="popup__certification">
                    <div class="popup__tit">
                        <h2>{{ currentSlideTitle }}</h2>
                        <button type="button" class="popup__close" @click="popupBtn"><img src="/resource/icon/close.svg" alt=""></button>
                    </div>
                    <div class="popup__body">
                        <div class="subSwiper info">
                            <swiper ref="mySwiper" :navigation="{
                                nextEl: '.subSwiper-next',
                                prevEl: '.subSwiper-prev'
                              }" :pagination="{ clickable: true }" :grabCursor="true" :effect="'creative'" :creativeEffect="{
                                prev: {
                                    shadow: true,
                                    translate: ['-20%', 0, -1],
                                },
                                next: {
                                    translate: ['100%', 0, 0],
                                },
                                }" :speed="700" :modules="modules" @swiper="onSwiperInit">
                                <swiper-slide data-tit="4-р давхрын лобби">
                                    <img src="/resource/img/img_view_gallery01.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide data-tit="3-р давхрын лобби">
                                    <img src="/resource/img/img_view_gallery02.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide data-tit="3 давхарт лобби коридор">
                                    <img src="/resource/img/img_view_gallery03.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide data-tit="4 давхарт лобби коридор">
                                    <img src="/resource/img/img_view_gallery04.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide data-tit="Хэрэглэгчийн цахилгаан шат">
                                    <img src="/resource/img/img_view_gallery05.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide data-tit="4-р давхарт Хөхний маммографийн өрөө">
                                    <img src="/resource/img/img_view_gallery06.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide data-tit="4-р давхарт Дурангийн шинжилгээний өрөө">
                                    <img src="/resource/img/img_view_gallery07.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide data-tit="4-р давхарт CT шинжилгээний өрөө">
                                    <img src="/resource/img/img_view_gallery08.jpg" alt="">
                                </swiper-slide>
                            </swiper>
                            <div class="subSwiper-bth subSwiper-next"></div>
                            <div class="subSwiper-bth subSwiper-prev"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="img-slide">
            <div class="img-slide__box img-slide__box1">
                <div class="left">
                    <button type="button" class="btn" @click="slideFn(1)">
                        <p class="hover">4-р давхрын лобби</p>
                        <img src="/resource/img/img_view_gallery01.jpg" alt="">
                    </button>
                </div>
                <div class="right">
                    <button type="button" class="btn" @click="slideFn(2)">
                        <p class="hover">3-р давхрын лобби</p>
                        <img src="/resource/img/img_view_gallery02.jpg" alt="">
                    </button>
                    <button type="button" class="btn" @click="slideFn(3)">
                        <p class="hover">3 давхарт лобби коридор</p>
                        <img src="/resource/img/img_view_gallery03.jpg" alt="">
                    </button>
                    <button type="button" class="btn" @click="slideFn(4)">
                        <p class="hover">4 давхарт лобби коридор</p>
                        <img src="/resource/img/img_view_gallery04.jpg" style="object-position: 30%;" alt="">
                    </button>
                    <button type="button" class="btn" @click="slideFn(5)">
                        <p class="hover">Хэрэглэгчийн цахилгаан шат</p>
                        <img src="/resource/img/img_view_gallery05.jpg" alt="">
                    </button>
                </div>
            </div>
            <div class="img-slide__box img-slide__box2">
                <div class="left">
                    <button type="button" class="btn" @click="slideFn(6)">
                        <p class="hover">4-р давхарт Хөхний маммографийн өрөө</p>
                        <img src="/resource/img/img_view_gallery06.jpg" alt="">
                    </button>
                    <button type="button" class="btn" @click="slideFn(7)">
                        <p class="hover">4-р давхарт Дурангийн шинжилгээний өрөө</p>
                        <img src="/resource/img/img_view_gallery07.jpg" alt="">
                    </button>
                </div>
                <div class="right">
                    <button type="button" class="btn" @click="slideFn(8)">
                        <p class="hover">4-р давхарт CT шинжилгээний өрөө</p>
                        <img src="/resource/img/img_view_gallery08.jpg" alt="">
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';
    import { EffectCreative } from 'swiper/modules';
    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard, EffectCreative],
            };
        },
        data() {
            return {
                slideNum: '',
                popupShow: false,
                swiperInstance: null,
                currentSlideTitle: '' // 현재 슬라이드의 제목
            }
        },
        methods: {
            onSwiperInit(swiper) {
                this.swiperInstance = swiper;

                // 초기 슬라이드 제목 설정
                const initialSlide = swiper.slides[swiper.activeIndex];
                this.currentSlideTitle = initialSlide.dataset.tit;

                // 슬라이드 변경 이벤트 리스너 추가
                swiper.on('slideChange', () => {
                    const activeSlide = swiper.slides[swiper.activeIndex];
                    this.currentSlideTitle = activeSlide.dataset.tit;
                });
            },
            slideFn(num) {
                this.slideNum = num;
                if (window.innerWidth >= 720) {
                    this.popupShow = true;
                }

                if (this.swiperInstance) {
                    this.swiperInstance.slideTo(num - 1);

                    // 슬라이드 이동 시 제목 업데이트
                    const targetSlide = this.swiperInstance.slides[num - 1];
                    this.currentSlideTitle = targetSlide.dataset.tit;
                }
            },
            popupBtn() {
                if (window.innerWidth >= 720) {
                    this.popupShow = !this.popupShow;
                }
            }
        },
    };

</script>